import { InfoSectionData } from '../field/FieldInfoButton';

// Для страницы профиля - полученные приглашения
export const receivedInvitationsInfo: InfoSectionData[] = [
  {
    title: 'Overview',
    description: `
      <strong>Received Invitations</strong> - invitations from clans that want you to join them.
      When a clan leader or senior officer invites you, the invitation appears here.
    `,
  },
  {
    title: 'How It Works',
    description: `
      • You can be invited to multiple clans for different game types<br/>
      • If you have a pending application to a clan and they invite you, you'll be auto-joined<br/>
      • You can only be a member of one clan per game type (airsoft, paintball, speedball)
    `,
  },
  {
    title: 'Available Actions',
    fields: [
      {
        name: 'Accept',
        description: 'Join the clan immediately. You will become a member with basic permissions.',
      },
      {
        name: 'Decline',
        description: 'Reject the invitation. The clan can send you a new invitation later if they wish.',
      },
      {
        name: 'View Clan',
        description: 'Click on the clan name to view the clan profile before making a decision.',
      },
    ],
  },
];

// Для страницы профиля - мои заявки
export const myApplicationsInfo: InfoSectionData[] = [
  {
    title: 'Overview',
    description: `
      <strong>My Applications</strong> - your pending requests to join clans.
      When you apply to a clan, your application appears here until it's processed.
    `,
  },
  {
    title: 'Application Rules',
    description: `
      • You can only have <strong>one active application per game type</strong><br/>
      • To apply to a different clan, you must first withdraw your current application<br/>
      • If a clan has already invited you and you apply, you'll be auto-joined
    `,
  },
  {
    title: 'Application Status',
    fields: [
      {
        name: 'Pending',
        description: 'Your application is waiting for review by clan leadership.',
      },
      {
        name: 'Accepted',
        description: 'Congratulations! You are now a member of the clan.',
      },
      {
        name: 'Declined',
        description: 'The clan has declined your application. You can apply to other clans.',
      },
    ],
  },
  {
    title: 'Available Actions',
    fields: [
      {
        name: 'Withdraw',
        description: 'Cancel your application. Use this to apply to a different clan instead.',
      },
      {
        name: 'View Clan',
        description: 'Click on the clan name to view the clan profile.',
      },
    ],
  },
];

// Для страницы клана - управление заявками (для лидера/офицера)
export const clanApplicationsManagementInfo: InfoSectionData[] = [
  {
    title: 'Overview',
    description: `
      <strong>Clan Applications</strong> - requests from players who want to join your clan.
      As a clan leader or senior officer, you can approve or decline these requests.
    `,
  },
  {
    title: 'Managing Applications',
    description: `
      • Review each application carefully before making a decision<br/>
      • Click on a player's name to view their profile and stats<br/>
      • Approved players become members immediately with basic permissions
    `,
  },
  {
    title: 'Available Actions',
    fields: [
      {
        name: 'Approve',
        description: 'Accept the player into your clan. They become a member immediately.',
      },
      {
        name: 'Decline',
        description: 'Reject the application. The player can apply again later if they wish.',
      },
      {
        name: 'View Profile',
        description: 'Click on the player name to check their stats and history before deciding.',
      },
    ],
  },
  {
    title: 'Auto-Join Feature',
    description: `
      If you send an invitation to a player who has already applied to your clan,
      they will be <strong>automatically joined</strong> without needing further action.
    `,
  },
];

// Для страницы клана - отправленные приглашения (для лидера/офицера)
export const clanInvitationsManagementInfo: InfoSectionData[] = [
  {
    title: 'Overview',
    description: `
      <strong>Sent Invitations</strong> - invitations you've sent to players to join your clan.
      Track pending invitations and manage them here.
    `,
  },
  {
    title: 'Invitation Process',
    description: `
      • Use "Invite Member" button in the sidebar to send new invitations<br/>
      • Search for players by name to find potential recruits<br/>
      • Players will see the invitation in their profile's Clan Requests section
    `,
  },
  {
    title: 'Invitation Status',
    fields: [
      {
        name: 'Pending',
        description: 'The player hasn\'t responded yet. They can accept or decline.',
      },
      {
        name: 'Accepted',
        description: 'The player has joined your clan.',
      },
      {
        name: 'Declined',
        description: 'The player has rejected the invitation.',
      },
    ],
  },
  {
    title: 'Available Actions',
    fields: [
      {
        name: 'Withdraw',
        description: 'Cancel the pending invitation. Useful if you sent it by mistake or changed your mind.',
      },
      {
        name: 'View Profile',
        description: 'Click on the player name to view their profile.',
      },
    ],
  },
  {
    title: 'Auto-Join Feature',
    description: `
      If you invite a player who has already applied to your clan,
      they will be <strong>automatically joined</strong> without needing to accept the invitation.
    `,
  },
];
